<template>
    <div class="layout-float">
      <ul>
        
          <Popover overlayClassName="helper-popover" placement="top">
              <template #content>
                <div class="helper-box">
                  <h1>Hello~</h1>
                  <p>我们是象刀设计团队，有任何体验问题或产品建议，欢迎扫码进群交流，我们会及时尽力为您解决。</p>
                  <ul>
                    <li>
                      <img src="../../../assets/images/home/kfq.png"/>
                    </li>

                  </ul>
                </div>
              </template>
              <li class="kefu"><svg-icon name="kefu" width="23" height="22"></svg-icon></li>
            </Popover>
        <BackTop><li><svg-icon name="backtop" width="17" height="24"></svg-icon></li></BackTop>
      </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'header',
  setup() {
    return {
    }
  },
})
</script>

<style lang="scss" scoped>
.layout-float {
  position: fixed;
  bottom: 80px;
  right: 5px;
  z-index: 999;
  li {
    width: 40px;
    height: 40px;
    background-color: #fff;
    box-shadow: 0 0 8px 0 rgba($color: #000, $alpha: 0.1);
    margin: 10px 0;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  li:hover {
    background-color: #f5f5f5;
    box-shadow: 0 4px 8px 0 rgba($color: #000, $alpha: 0.1);
  }
}
</style>